<div class="container-fluid">
  <div class="row top10 ">
    <div class="col-xs-12 ">
      <h3>Inventory Config</h3>
    </div>
  </div>
  <hr style="margin-top: 2px; margin-bottom: 2px" />

  <div class="row top10">
    <mat-tab-group>
        <mat-tab label="Parameters">
          <ng-template matTabContent>
            <div class="table-container">

              <aims-form [editable]="true" [cols]="1" [spaceRows]="true">
                <aims-fc [labelColSize]="2" [controlColSize]="6">
                    <mat-checkbox
                        #aimsControl="ngModel"
                        name="Use Auto-Numbering"
                        [(ngModel)]="inventoryConfig.useAutoNumbering"
                        (change)="updateConfig()"
                        [disabled]="disabledRO">
                    </mat-checkbox>
                  </aims-fc>

                  <aims-fc [labelColSize]="2" [controlColSize]="6">
                    <mat-form-field appearance="fill">
                      <input
                        matInput
                        #aimsControl="ngModel"
                        type="text"
                        name="Inventory Item Auto-Numbering Mask"
                        [(ngModel)]="inventoryConfig.autoNumberMask"
                        (blur)="updateConfig()"
                        [disabled]="!inventoryConfig.useAutoNumbering || disabledRO"
                      />
                    </mat-form-field>
                  </aims-fc>

                  <aims-fc [labelColSize]="2" [controlColSize]="6">
                    <aims-numeric
                        required
                        [numericType]="AIMS_NUMERIC_TYPES.NUMBER"
                        #aimsControl="ngModel"
                        name="Auto-Numbering Start Value"
                        [(ngModel)]="inventoryConfig.autoNumberStartValue"
                        [min]="0"
                        [disabled]="!inventoryConfig.useAutoNumbering || disabledRO"
                        (blur)="updateConfig()">
                    </aims-numeric>
                  </aims-fc>

                  <aims-fc [labelColSize]="2" [controlColSize]="6">
                    <aims-numeric
                        required
                        [numericType]="AIMS_NUMERIC_TYPES.NUMBER"
                        #aimsControl="ngModel"
                        name="Item Number Length"
                        [(ngModel)]="inventoryConfig.inventoryItemNumberLength"
                        [min]="1"
                        [max]="25"
                        [disabled]="disabledRO"
                        (blur)="updateConfig()">
                    </aims-numeric>
                  </aims-fc>

                  <aims-fc [labelColSize]="2" [controlColSize]="6">
                    <mat-checkbox
                        #aimsControl="ngModel"
                        name="Use Auto-Reorder"
                        id="autoreorder"
                        [(ngModel)]="inventoryConfig.allowAutoRefill"
                        (change)="updateConfig()"
                        [disabled]="disabledRO">
                    </mat-checkbox>
                  </aims-fc>

                  <aims-fc [labelColSize]="2" [controlColSize]="6">
                    <aims-lookup #aimsControl="ngModel"
                      name="Reorder Route"
                      [gridText]="'Select a Reorder Route'"
                      id="reorderRoute"
                      [values]="reqRouting | async"
                      [idPropertyName]="'routingSectionId'"
                      [displayPropertyName]="'routingSection'"
                      [(ngModel)]="inventoryConfig.reorderRoutingSectionId"
                      [gridText]="'Select a route'"
                      [columnsInGrid]="routeLookupColumns"
                      class="fullWidth"
                      (valueChangeObj)="handleRoutingCompontLookupChange($event, element, dynamicControl)"
                      [disabled]="disabledRO || !inventoryConfig.allowAutoRefill"
                      >
                    </aims-lookup>
                  </aims-fc>

                  <aims-fc [labelColSize]="2" [controlColSize]="6">
                    <mat-form-field>
                      <mat-select #aimsControl="ngModel"
                          [(ngModel)]="inventoryConfig.reorderStatusId"
                          name="Reorder Status"
                          [disabled]="disabledRO || !inventoryConfig.allowAutoRefill"
                          (selectionChange)="updateConfig()"
                          required>
                          <mat-option *ngFor="let e of reqStatusValues | async" [value]="e.reqStatusId">
                            {{ e.reqStatus }}
                          </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </aims-fc>

                  <aims-fc [labelColSize]="2" [controlColSize]="6">
                    <mat-form-field>
                      <mat-select #aimsControl="ngModel"
                          [(ngModel)]="inventoryConfig.reorderEmpId"
                          name="Reorder Requestor"
                          [disabled]="disabledRO || !inventoryConfig.allowAutoRefill"
                          (selectionChange)="updateConfig()"
                          required>
                          <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId">
                            {{ e.fullName }}
                          </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </aims-fc>

                </aims-form>

              </div>
            </ng-template>
        </mat-tab>

      <mat-tab label="Inventory Groups">
        <form novalidate #grpGrid="ngForm">
          <div class="table-container">
            <aims-common-table
              [dataSource]="inventoryGroups | async"
              [defaultTableState]="defaultTableState"
              [header]="inventoryGroupTableColumns"
              [permissions]="inventoryGroupTablePermissions"
              id="InventoryGroupConfigTable"
              (rowEdit)="handleRowEdit($event)"
              [stickyHeader]="true"
            >
              <ng-template aimsCommonTableDynamicToolbar>
                <aims-common-button aria-label="Add" (click)="handleRowAdd()" *ngIf="!disabledRO">
                  <mat-icon>add</mat-icon>
                  Add
                </aims-common-button>
              </ng-template>

            </aims-common-table>
          </div>
        </form>
      </mat-tab>

      <mat-tab label="Locations">
          <ng-template matTabContent>
              <div class="table-container">
                  <aims-config-locations [permissionNeeded]="permissions.ComponentID.InventoryConfig"></aims-config-locations>
              </div>
          </ng-template>
      </mat-tab>

      <mat-tab label="Sub Locations">
          <ng-template matTabContent>
              <div class="table-container">
                <aims-config-sub-locations [permissionNeeded]="permissions.ComponentID.InventoryConfig"></aims-config-sub-locations>
              </div>
          </ng-template>
      </mat-tab>

      <mat-tab label="Manufacturers">
          <ng-template matTabContent>
              <div class="table-container">
                  <aims-config-manufacturers [permissionNeeded]="permissions.ComponentID.InventoryConfig"></aims-config-manufacturers>
              </div>
          </ng-template>
        </mat-tab>

      <mat-tab label="Owners">
          <ng-template matTabContent>
              <div class="table-container">
                  <aims-config-owners [permissionNeeded]="permissions.ComponentID.InventoryConfig"></aims-config-owners>
              </div>
          </ng-template>
      </mat-tab>

    </mat-tab-group>
  </div>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
